import { forwardRef, type Ref, type SVGProps } from "react";

function SvgRebrandChatColored(props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) {
  return (
    <svg ref={ref} xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" {...props}>
      <path
        fill="#ECE7DC"
        stroke="#210E10"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={1.5}
        d="M12.5 21.25a9.25 9.25 0 1 0-8.486-5.562c.157.36.198.764.082 1.14l-.775 2.512c-.353 1.141.705 2.216 1.852 1.883l2.653-.771a1.65 1.65 0 0 1 1.094.08 9.2 9.2 0 0 0 3.58.718"
      />
    </svg>
  );
}
const ForwardRef = forwardRef(SvgRebrandChatColored);
export default ForwardRef;
